(function() {
  angular.module('cfn').directive('dLoading', function() {
    'use strict';
    return {
      restrict: 'EA',
      scope: {
        text: '='
      },
      template:
        "<div style='display:block;position:absolute;width:100%;height:100%;background:rgba(200,200,200,0.7);z-index:10000;text-align:center;'>" +
        "<div style='margin: 200px auto; background: #fff; max-width: 400px; max-height: 100%; overflow: auto; padding: 20px; border: 1px solid #aaa;'>" +
        "<div style='margin-top: 2px' class='spinner'>" +
        "<div class='bounce1'></div><div class='bounce2'></div><div class='bounce3'></div><div class='bounce4'></div></div>" +
        '<div>{{text}}</div>' +
        '</div></div>'
    };
  });
})();
